import { format } from 'date-fns';
import { getStructSetoid, setoidDate, setoidString } from 'fp-ts/lib/Setoid';
import { partial, string } from 'io-ts';
import { DateFromISOString } from 'io-ts-types';
import { nullableSetoid } from '../utils/object.utils';
export var MaintenanceInfoIO = partial({
    timeFrom: DateFromISOString,
    timeTo: DateFromISOString,
    blockMessage: string,
    warningMessage: string,
});
var dateTimeFormat = 'M/D/YYYY hh:mm a';
export var setoidMaintenanceInfo = getStructSetoid({
    blockMessage: nullableSetoid(setoidString),
    timeFrom: nullableSetoid(setoidDate),
    timeTo: nullableSetoid(setoidDate),
    warningMessage: nullableSetoid(setoidString),
});
export function isMaintenanceInProgress(info) {
    var now = Date.now();
    if (info.timeFrom && info.timeFrom.getTime() > now) {
        return false; // not yet started
    }
    if (info.timeTo && info.timeTo.getTime() < now) {
        return false; // already finished
    }
    return true;
}
export function formatMaintenanceText(info) {
    if (isMaintenanceInProgress(info)) {
        return info.blockMessage || "Volley is undergoing scheduled maintenance we'll be back online shortly!";
    }
    else {
        var timeFrom = info.timeFrom, timeTo = info.timeTo, warningMessage = info.warningMessage;
        if (warningMessage) {
            return warningMessage;
        }
        else {
            var dateRange = timeFrom
                ? ' from ' + format(timeFrom, dateTimeFormat) + (timeTo ? ' to ' + format(timeTo, dateTimeFormat) : '')
                : timeTo
                    ? ' until ' + format(timeTo, dateTimeFormat)
                    : '';
            return "Volley is planning maintenance" + dateRange + ".";
        }
    }
}
//# sourceMappingURL=maintenance.model.js.map